import styled from 'styled-components';

export const ContentWrapper = styled.div`
  margin-bottom: 7rem;
  background-color: rgb(255, 255, 255);
  box-shadow: rgba(0, 0, 0, 0.25) 0px 0.1rem 0.4rem 0px;
  border-radius: 0.6rem;
  padding: 3rem 2rem;
  width: 100%;
  font-size: 1.4rem;
  ul {
    display: flex;
    flex-direction: column;
    width: 100%;
    li {
      padding-bottom: 1rem;
    }
  }
`;

export const CollapseWrapper = styled.div(props=>`
max-height:${props.readMore ? '15rem':'unset'}
z-index: 1;
overflow: hidden;
p{
    padding:1rem 0;
    font-size: 1.6rem;
}
`);

export const ReadMore = styled.div`
  box-shadow: rgb(255 255 255) 0px -1.5rem 1.5rem 0.5rem;
  z-index: 2;
  color: rgb(34, 118, 227);
  cursor:pointer;
  padding-top:1rem;
  font-size: 1.4rem;
`;
